import { render, staticRenderFns } from "./gap.vue?vue&type=template&id=04002ed6&"
import script from "./gap.vue?vue&type=script&lang=js&"
export * from "./gap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports